<template>

    <rkm-table
        :items="medicamentosFiltrados"
        :fields="fields"
        hide-filters
        hide-pagination        
    >

        <template
            v-for="mes in 6"
            #[`cell(mes${mes})`]="row"
        >

            <rkm-form-input
                v-model="row.item.quantidades[mes]"
                :key="mes"
                disabled
            />
        </template>

    </rkm-table>
</template>

<script>
// Enums
import geralMedidaTempo from '@/enums/geral/medidaTempo'
import tipoReceita from '@/enums/cadastro/medicamento/tipoReceita'
export default {

    data(){
        return{
            enums:{
                geralMedidaTempo,
                tipoReceita
            },
            FATOR_TEMPO_DIAS:{
                3: 1,
                4: 7, 
                5: 30
            }
        }
    },
    created() {
        this.data.model.prescricaoMedicamentos.forEach(medicamento => {
            if (!medicamento.quantidades) {

                medicamento.quantidades = {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null,
                    6: null
                }
            }
            this.preencherQuantidadeMeses(medicamento)
        })
    },

    computed: {
        medicamentosFiltrados() {
            return this.data.model.prescricaoMedicamentos.filter(medicamento =>
                medicamento.material.receitaTipoId != this.enums.tipoReceita.COMUM 
            )
        },
        fields() {

            return [
                {
                    key: 'material.descricao',
                    label: 'Medicamento'
                },

                {
                    key: 'mes1',
                    label: '1º Mês'
                },

                {
                    key: 'mes2',
                    label: '2º Mês'
                },

                {
                    key: 'mes3',
                    label: '3º Mês'
                },

                {
                    key: 'mes4',
                    label: '4º Mês'
                },

                {
                    key: 'mes5',
                    label: '5º Mês'
                },

                {
                    key: 'mes6',
                    label: '6º Mês'
                }
            ]

        }
    },
    methods: {
        converterParaDias(valor, medidaId) {
            const fator = this.FATOR_TEMPO_DIAS[medidaId] ?? 1
            return Number(valor || 0) * fator
        },
        getDuracaoDias(medicamento) {
            return this.converterParaDias(
                medicamento.duracao,
                medicamento.duracaoMedidaTempoId
            )
        },
        getIntervaloDias(medicamento) {
            return this.converterParaDias(medicamento.intervalo, medicamento.intervaloMedidaTempoId)
        },
        calculaIntervalo(medicamento) {
            const dosesPorDia = 24 / Number(medicamento.intervalo || 1)
            return dosesPorDia * Number(medicamento.dose || 0)
        },
        calculaFrequencia(medicamento) {
            const intervaloDias = this.getIntervaloDias(medicamento)
            if (!intervaloDias) return 0

            return ((Number(medicamento.frequenciaVezes || 0) / intervaloDias) * Number(medicamento.dose || 0))
        },
        calculaTurno(medicamento) {
            const intervaloDias = this.getIntervaloDias(medicamento)

            if (!intervaloDias) return 0

            return Number(medicamento.dose || 0) / intervaloDias
        },
        getQtdePorDia(medicamento) {
            if (medicamento.frequenciaDose === 'intervalo') {
                    return this.calculaIntervalo(medicamento)
            }

            if (medicamento.frequenciaDose === 'frequencia') {
                    return this.calculaFrequencia(medicamento)
            }

            if(medicamento.frequenciaDose === 'turno'){
                    return this.calculaTurno(medicamento)
            }

            return 0
        },
        preencherQuantidadeMeses(medicamento) {
            const quantidades = {}
            let diasRestantes = this.getDuracaoDias(medicamento)
            const qtdePorDia = this.getQtdePorDia(medicamento)

            const vazio = {
                1: null, 2: null, 3: null,
                4: null, 5: null, 6: null
            }

            if (!diasRestantes || !qtdePorDia) {
                medicamento.quantidades = vazio
                return
            }

            for (let mes = 1; mes <= 6 && diasRestantes > 0; mes++) {
                const diasNoMes = Math.min(diasRestantes, 30)

                quantidades[mes] = diasNoMes * qtdePorDia
                diasRestantes -= diasNoMes
            }

            medicamento.quantidades = quantidades
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
}

</script>